import React, { useState, useEffect, useRef } from 'react';

const ASPECT_RATIO = 480 / 854;

const calcSize = () => {
    // Reserve space for the header (7vh) plus padding, leaving 85vh for the iframe
    const maxHeight = window.innerHeight * 0.85;
    const maxWidth = window.innerWidth * 0.9;
    // Constrain by both width and height, maintaining aspect ratio
    const widthFromHeight = maxHeight / ASPECT_RATIO;
    const width = Math.min(maxWidth, widthFromHeight);
    return { width, height: width * ASPECT_RATIO };
};

const ResponsiveIframe = (url) => {
    const [iframeSize, setIframeSize] = useState(calcSize);

    const iframeRef = useRef(null);

    useEffect(() => {
	const handleResize = () => {
	    setIframeSize(calcSize());
	};
	
	// Set the resize listener
	window.addEventListener('resize', handleResize);
	
	// Call the handler right away so state gets updated with initial window size
	handleResize();
	
	// Remove event listener on cleanup
	return () => window.removeEventListener('resize', handleResize);
    }, []); // Empty array ensures that effect is only run on mount and unmount
    
    return (
	<iframe
	    ref={iframeRef}
	    src={url.url}
	    width={iframeSize.width}
	    height={iframeSize.height}
	    style={{ border: 'none' }} // Add any additional styles if needed
	    title="Showreel"
            frameBorder="0"
            allowFullScreen
	/>
    );
    
}

export default ResponsiveIframe;
